import http from '@/utils/http';
const base_path = '/v2/tool/brand';

/**
 * 获取品牌形象列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getBrandListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 新增品牌形象接口
 * @param {Object} data 请求参数
 * @returns {Promise<Object>}
 */
export const addBrandApi = (data) => {
  return http.post({
    url: base_path,
    data,
  });
};

/**
 * 获取品牌形象分类列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getBrandCategoryListApi = (params) => {
  return http.get({
    url: `${base_path}/category`,
    params,
  });
};
